//缓存页面搜索数据
let ache = {};
//data需要为普通对象
const addCache = (type, data) => {
  console.log("缓存数据", data);
  if (!data) {
    ache[type] = "";
  }
  ache[type] = JSON.stringify(data);
};
const getCache = (type) => {
  if (ache[type]) {
    return JSON.parse(ache[type]);
  } else {
    return false;
  }
};
//data需要为普通对象,已经存在时才进行更新
const updateCache = (type, data, timeout) => {
  let update = () => {
    let obj = {};
    obj = JSON.parse(ache[type]);
    obj = { ...obj, ...data };
    console.log("更新后的对象", obj);
    ache[type] = JSON.stringify(obj);
  };
  if (ache[type]) {
    if (typeof timeout == "number") {
      setTimeout(update, timeout);
    } else {
      update();
    }
  }
};
export { addCache, getCache, updateCache };
